/**
 * This class is responsible for the PDC extras related to the container
 */
class PdcExtras {

    manufacturerType = null;
    // DISABLED: Backend endpoint removed
    // endpoint = _ENDPOINT_;
    endpoint = null;
    domElements = {
        palletQuantityButton: null
    };

    constructor() {
        //Recover the lgchoon_product_filtered_type key from localStorage (it stores the type of fabric)
        this.manufacturerType = localStorage.getItem('lgchoon_product_filtered_type');
        //check if the container has a type (it have priority over the localStorage one)
        if(globalContainerApp != null){
            if(globalContainerApp.appContainer != null) {
                if(globalContainerApp.appContainer.manufacturerType != null) {
                    this.manufacturerType = globalContainerApp.appContainer.manufacturerType;
                }
            }
        }


        if(this.manufacturerType !== null) {
            //conver the code to the value in the filter
            switch(this.manufacturerType) {
                case 'gres_cemento':
                    this.manufacturerType = 'Gres y cemento';
            }
            this.selectAutoFilter();
        }
    }


    /**
     * Selects an auto filter based on the manufacturer type.
     *
     * @returns {void} - This method does not return a value.
     */
    selectAutoFilter() {
        let checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.manufacturer_name"]');
        console.log(checkboxes);
        let alreadyChecked = false;
        for(let checkbox of checkboxes){
            //First, check if there's any already checked
            if(checkbox.checked) {
                alreadyChecked = true;
                break;
            }
        }
        //Now, if no one is checked, iterate and search one with the same value as this.manufacturerType, then check it
        if(!alreadyChecked) {
            for(let checkbox of checkboxes){
                console.log(checkbox.value, this.manufacturerType);
                if(checkbox.value == this.manufacturerType) {
                    checkbox.click();
                    break;
                }
            }
        }
    }
}

/**
 * PDP app depends on the globalContainerApp to be bootstrapped first
 */
const boostrapPDCExtrasInterval = setInterval(() => {
    //First of all, await for globalContainerAPP to be bootstrapped
    if(typeof globalContainerApp != 'undefined' || globalContainerApp != null) {
        //Bootstrap
        new PdcExtras();
        clearInterval(boostrapPDCExtrasInterval);
    }
}, 500);
